import { Utils } from './utils'
export { Utils } from './utils'

export default Utils



// WEBPACK FOOTER //
// ../../src/utils/index.ts